/**
 * The "Beta" chip for chart chrome — sits beside a settings-row label, a
 * chart-type picker entry, or a menu row for a feature that ships opt-in while
 * it is still being tuned. One component so every surface reads the same.
 *
 * Standalone by design, like `HotkeyBadge`: styles off the chart CSS variables
 * (`--chart-text`) with no app-level dependency, so charts-core stays
 * self-contained. Call sites tune placement via `className`.
 */
export function BetaTag({ className = '' }: { className?: string }) {
  return (
    <span
      title="Beta feature — may change or be removed"
      className={
        'inline-flex h-[14px] shrink-0 items-center rounded-sm border border-[hsl(var(--chart-text)/0.25)] px-1 text-[9px] font-semibold uppercase leading-none tracking-wider text-[hsl(var(--chart-text-muted))] ' +
        className
      }
    >
      Beta
    </span>
  )
}
